import axios from '@plugins/axios'
import store from '@state/store'
import config from '@src/app.config'
const env = config.env
const appConfig = config[env]

export const state = {
  loading: false,
  areas: {
    results: []
  },
  changes: {
    results: []
  },
  actors: {
    results: []
  },
  objectives: {
    results: []
  },
  changeFactors: {
    results: []
  },
  wordsCloud: {
    results: []
  },
  wordsCorrelation: {
    results: []
  },
  excludedWords: {
    results: []
  },
  scenaryVariables: {
    results: []
  },
  sceneries: {
    results: []
  },
  variablesSceneriesToRate: {
    results: []
  },
  variablesSceneriesRated: {
    results: []
  },
  sceneriesReport: [],
  sceneriesExperts: {
    results: []
  },
  variable_assigned: false,
  morphAnalysis: {
    results: []
  }
}

export const getters = {
  loading: state => state.loading,
  areas: state => state.areas,
  changes: state => state.changes,
  actors: state => state.actors,
  objectives: state => state.objectives,
  changeFactors: state => state.changeFactors,
  wordsCloud: state => state.wordsCloud,
  wordsCorrelation: state => state.wordsCorrelation,
  variablesAssigned: state => state.variable_assigned,
  excludedWords: state => state.excludedWords,
  scenaryVariables: state => state.scenaryVariables,
  sceneries: state => state.sceneries,
  variablesSceneriesToRate: state => state.variablesSceneriesToRate,
  variablesSceneriesRated: state => state.variablesSceneriesRated,
  sceneriesReport: state => state.sceneriesReport,
  sceneriesExperts: state => state.sceneriesExperts,
  morphAnalysis: state => state.morphAnalysis,
}

export const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_AREAS(state, areas) {
    state.areas = areas
  },
  SET_CHANGES(state, changes) {
    state.changes = changes
  },
  SET_ACTORS(state, actors) {
    state.actors = actors
  },
  SET_OBJECTIVES(state, objectives) {
    state.objectives = objectives
  },
  SET_CHANGE_FACTORS(state, changeFactors) {
    state.changeFactors = changeFactors
  },
  SET_WORDS_CLOUD(state, wordsCloud) {
    state.wordsCloud = wordsCloud
  },
  SET_WORDS_CORRELATION(state, wordsCorrelation) {
    state.wordsCorrelation = wordsCorrelation
  },
  SET_VARIABLE_ASSIGNED(state, assigned) {
    state.variable_assigned = assigned
  },
  SET_EXCLUDED_WORDS(state, excludedWords) {
    state.excludedWords = excludedWords
  },
  SET_SCENARY_VARIABLES(state, scenaryVariables) {
    state.scenaryVariables = scenaryVariables
  },
  SET_ESCENERIES(state, sceneries) {
    state.sceneries = sceneries
  },
  SET_VARIABLES_SCENERIES_TO_RATE(state, data) {
    state.variablesSceneriesToRate = data
  },
  SET_VARIABLES_SCENERIES_RATED(state, data) {
    state.variablesSceneriesRated = data
  },
  SET_SCENERIES_REPORT(state, data) {
    state.sceneriesReport = data
  },
  SET_SCENERIES_EXPERTS(state, data) {
    state.sceneriesExperts = data
  },
  SET_MORPH_DATA(state, data){
    state.morphAnalysis = data
  }
}

export const actions = {
  fetchAreas({ commit }, projectId) {
    return new Promise((resolve, reject) => {
      commit('SET_LOADING', true)
      axios.get(appConfig.server_url + `/projects_management/ambit/?project_id=${projectId}`)
        .then(resp => {
          commit('SET_AREAS', resp.data)
          commit('SET_LOADING', false)
          resolve(resp)
        })
        .catch((error) => {
          commit('SET_LOADING', false)
          store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error consultando ámbitos' })
          reject(error)
        })
    })
  },
  createArea({ dispatch }, payload) {
    axios.post(appConfig.server_url + `/projects_management/ambit/`, payload)
      .then(resp => {
        dispatch('fetchAreas', payload.project_id)
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Creado correctamente.' })
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error realizando acción' })
      })
  },
  updateArea({ dispatch }, payload) {
    axios.put(payload.url, payload)
      .then(resp => {
        dispatch('fetchAreas', payload.project_id)
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Actualizado correctamente.' })
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error realizando acción' })
      })
  },
  deleteArea({ dispatch }, payload) {
    axios.delete(payload.url)
      .then(resp => {
        dispatch('fetchAreas', payload.projectId)
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Eliminado correctamente.' })
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error realizando acción' })
      })
  },
  fetchChanges({ commit }, projectId) {
    return new Promise((resolve, reject) => {
      commit('SET_LOADING', true)
      axios.get(appConfig.server_url + `/projects_management/change/?project_id=${projectId}`)
        .then(resp => {
          commit('SET_CHANGES', resp.data)
          commit('SET_LOADING', false)
          resolve(resp)
        })
        .catch((error) => {
          commit('SET_LOADING', false)
          store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error consultando ámbitos' })
          reject(error)
        })
    })
  },
  createChange({ dispatch }, payload) {
    axios.post(appConfig.server_url + `/projects_management/change/`, payload)
      .then(resp => {
        dispatch('fetchChanges', payload.project_id)
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Creado correctamente.' })
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error realizando acción' })
      })
  },
  updateChange({ dispatch }, payload) {
    axios.put(payload.url, payload)
      .then(resp => {
        dispatch('fetchChanges', payload.project_id)
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Actualizado correctamente.' })
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error realizando acción' })
      })
  },
  deleteChange({ dispatch }, payload) {
    axios.delete(payload.url)
      .then(resp => {
        dispatch('fetchChanges', payload.projectId)
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Eliminado correctamente.' })
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error realizando acción' })
      })
  },
  fetchActors({ commit }, projectId) {
    commit('SET_LOADING', true)
    axios.get(appConfig.server_url + `/projects_management/actor/?project_id=${projectId}`)
      .then(resp => {
        commit('SET_ACTORS', resp.data)
        commit('SET_LOADING', false)
      })
      .catch(() => {
        commit('SET_LOADING', false)
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error consultando Actores' })
      })
  },
  createActor({ dispatch }, payload) {
    axios.post(appConfig.server_url + `/projects_management/actor/`, payload)
      .then(resp => {
        dispatch('fetchActors', payload.project_id)
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Creado correctamente.' })
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error realizando acción' })
      })
  },
  deleteActor({ dispatch }, payload) {
    axios.delete(payload.url)
      .then(resp => {
        dispatch('fetchActors', payload.projectId)
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Eliminado correctamente.' })
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error realizando acción' })
      })
  },
  fetchObjectives({ commit }, projectId) {
    commit('SET_LOADING', true)
    axios.get(appConfig.server_url + `/projects_management/objective/?project_id=${projectId}`)
      .then(resp => {
        commit('SET_OBJECTIVES', resp.data)
        commit('SET_LOADING', false)
      })
      .catch(() => {
        commit('SET_LOADING', false)
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error consultando Objetivos' })
      })
  },
  createObjective({ dispatch }, payload) {
    axios.post(appConfig.server_url + `/projects_management/objective/`, payload)
      .then(resp => {
        dispatch('fetchObjectives', payload.project_id)
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Creado correctamente.' })
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error realizando acción' })
      })
  },
  deleteObjective({ dispatch }, payload) {
    axios.delete(payload.url)
      .then(resp => {
        dispatch('fetchObjectives', payload.projectId)
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Eliminado correctamente.' })
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error realizando acción' })
      })
  },
  fetchChangeFactors({ commit }, projectId) {
    commit('SET_LOADING', true)
    axios.get(appConfig.server_url + `/projects_management/variable/?project_id=${projectId}`)
      .then(resp => {
        commit('SET_CHANGE_FACTORS', resp.data)
        commit('SET_LOADING', false)
      })
      .catch(() => {
        commit('SET_LOADING', false)
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error consultando Variables Estratégicas' })
      })
  },
  createChangeFactor({ dispatch }, payload) {
    axios.post(appConfig.server_url + `/projects_management/variable/`, payload)
      .then(resp => {
        dispatch('fetchChangeFactors', payload.project_id)
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Creado correctamente.' })
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error realizando acción' })
      })
  },
  updateChangeFactor({ dispatch }, payload) {
    axios.put(payload.url, payload)
      .then(resp => {
        dispatch('fetchChangeFactors', payload.project_id)
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Actualizado correctamente.' })
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error realizando acción' })
      })
  },
  deleteChangeFactor({ dispatch }, payload) {
    axios.delete(payload.url)
      .then(resp => {
        dispatch('fetchChangeFactors', payload.projectId)
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Eliminado correctamente.' })
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error realizando acción' })
      })
  },
  setExpertsScores({ dispatch, commit }, payload) {
    axios.post(appConfig.server_url + '/projects_management/clean/factormatrix', { project_id: payload.project_id })
      .then(resp => {
        if (resp.status === 200) {
          if (!resp.data.error && resp.data.affected_rows >= 0) {
            axios.post(appConfig.server_url + '/projects_management/generate/factormatrix', payload)
              .then(resp => {
                dispatch('fetchChangeFactors', payload.project_id)
                commit('SET_VARIABLE_ASSIGNED', true)
                store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Variables asignadas correctamente.' })
              })
              .catch(() => {
                store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error realizando acción' })
              })
          } else {
            store.dispatch('utils/message', { type: 'warn', title: 'Error', text: `No se ha podido reasignar variables: ${resp.data.error}` })
          }
        }
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error realizando acción' })
      })

  },
  fetchExpertsScores({ commit }, projectId) {
    axios.get(appConfig.server_url + `/projects_management/factormatrix/?project_id=${projectId}`)
      .then(resp => {
        commit('SET_VARIABLE_ASSIGNED', resp.data.count > 0)
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error realizando acción' })
      })
  },
  fetchWordsCloud({ commit }, payload) {
    commit('SET_LOADING', true)
    store.dispatch('utils/loaderMessage', 'Consultando nube de palabras...' )
    const { projectId, topWords } = payload
    axios.get(appConfig.server_url + `/projects_management/utils/wordoccurrences?project_id=${projectId}&top=${topWords}`)
      .then(resp => {
        commit('SET_WORDS_CLOUD', resp.data)
        commit('SET_LOADING', false)
        store.dispatch('utils/loaderMessage', '' )
      })
      .catch(() => {
        commit('SET_LOADING', false)
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error consultando Nube de Palabras' })
        store.dispatch('utils/loaderMessage', '' )
      })
  },
  fetchWordsCorrelation({ commit }, payload) {
    commit('SET_LOADING', true)
    store.dispatch('utils/loaderMessage', 'Consultando correlación de palabras...' )
    const { projectId, lowLimit, wordSearch } = payload
    axios.get(appConfig.server_url + `/projects_management/utils/wordcorrelations?project_id=${projectId}&low_limit=${lowLimit}`)
      .then(resp => {
        if (wordSearch !== "") {
          resp.data.response = resp.data.response.filter(x => wordSearch.toLowerCase().split(',')
                                                              .some(term => JSON.stringify(x).toLowerCase()
                                                              .includes(term.trim())));
        }
        commit('SET_WORDS_CORRELATION', resp.data)
        commit('SET_LOADING', false)
        store.dispatch('utils/loaderMessage', '' )
      })
      .catch(() => {
        commit('SET_LOADING', false)
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error consultando Correlación de Palabras' })
        store.dispatch('utils/loaderMessage', '' )
      })
  },
  fetchExcludedWords({ commit }, projectId) {
    commit('SET_LOADING', true)
    axios.get(appConfig.server_url + `/projects_management/excludedword/?project_id=${projectId}`)
      .then(resp => {
        commit('SET_EXCLUDED_WORDS', resp.data)
        commit('SET_LOADING', false)
      })
      .catch(() => {
        commit('SET_LOADING', false)
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error consultando palabras excluidas' })
      })
  },
  createExcludedWord({ dispatch }, payload) {
    axios.post(appConfig.server_url + `/projects_management/excludedword/`, payload)
      .then(resp => {
        dispatch('fetchExcludedWords', payload.project_id)
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Creado correctamente.' })
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error realizando acción' })
      })
  },
  deleteExcludedWord({ dispatch }, payload) {
    axios.delete(payload.url)
      .then(resp => {
        dispatch('fetchExcludedWords', payload.projectId)
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Eliminado correctamente.' })
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error realizando acción' })
      })
  },
  fetchScenaryVariables({ commit }, projectId) {
    axios.get(appConfig.server_url + `/projects_management/varhypothesis/?project_id=${projectId}`)
      .then(resp => {
        commit('SET_SCENARY_VARIABLES', resp.data)
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error realizando acción' })
      })
  },
  createScenaryVariables({ dispatch }, payload) {
    axios.post(appConfig.server_url + `/projects_management/varhypothesis/`, payload)
      .then(resp => {
        dispatch('fetchScenaryVariables', payload.project_id)
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error creando variable' })
      })

  },
  updateScenaryVariables({ dispatch }, payload) {
    axios.put(payload.url, payload)
      .then(resp => {
        dispatch('fetchScenaryVariables', payload.project_id)
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Variable actualizada correctamente.' })
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error actualizando variable' })
      })
  },
  deleteScenaryVariables({ dispatch }, payload) {
    axios.delete(payload.url, payload)
      .then(resp => {
        dispatch('fetchScenaryVariables', payload.projectId)
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error eliminando variable' })
      })
  },
  fetchSceneries({ commit }, payload ) {
    axios.get(appConfig.server_url + `/projects_management/hypothesis/?var_id=${payload.sceneryVariableId}`)
      .then(resp => {
        commit('SET_ESCENERIES', resp.data)
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error realizando acción' })
      })
  },
  createSceneries({ dispatch }, payload) {
    axios.post(appConfig.server_url + `/projects_management/hypothesis/`, payload)
      .then(resp => {
        dispatch('fetchSceneries', { sceneryVariableId: payload.var_id })
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Hipótesis creada correctamente.' })
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error realizando acción' })
      })
  },
  updateSceneries({ dispatch }, payload) {
    axios.put(payload.url, payload)
      .then(resp => {
        dispatch('fetchSceneries', { sceneryVariableId: payload.var_id })
        store.dispatch('utils/message', { type: 'success', title: 'Correcto', text: 'Hipótesis actualizado correctamente.' })
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error realizando acción' })
      })
  },
  deleteSceneries({ dispatch }, payload) {
    const data = payload.var.split('/')
    const sceneryVariableId = data[data.length - 2]
    axios.delete(payload.url)
      .then(resp => {
        dispatch('fetchSceneries', { sceneryVariableId })
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error realizando acción' })
      })
  },
  fetchVariablesSceneriesToRate({ commit }, payload) {
    const { projectId, profileId } = payload

    axios.get(appConfig.server_url + `/projects_management/scenario/?expert_id=${profileId}`)
      .then(resp => {
        commit('SET_VARIABLES_SCENERIES_RATED', resp.data)
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error realizando acción' })
      })

    axios.get(appConfig.server_url + `/projects_management/hypothesis/?project_id=${projectId}`)
      .then(resp => {
        commit('SET_ESCENERIES', resp.data)
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error realizando acción' })
      })
  },
  fetchSceneriesReport({ commit }, payload) {
    const { projectId } = payload

    let fetchAnswers = null
    let fetchVariables = null
    let fetchExperts = null

    commit('SET_LOADING', true)
    axios.get(appConfig.server_url + `/projects_management/scenario/?project_id=${projectId}`)
        .then(resp => {
          // let response = []
          // resp.data.results.forEach(element => {
          //   if (!response[element.expert])
          //      response[""+element.expert] = [];
          //   if (!response[element.expert][element.hypothesis_in_scenario.var])
          //      response[""+element.expert][""+element.hypothesis_in_scenario.var] = element.hypothesis_in_scenario.name
          // });

          fetchAnswers = resp.data
          

          axios.get(appConfig.server_url + `/projects_management/varhypothesis/?project_id=${projectId}`)
          .then(resp2 => {
            
            fetchVariables = resp2.data

            axios.get(appConfig.server_url + `/projects_management/scenarioexperts/?project_id=${projectId}`)
            .then(resp3 => {
              commit('SET_LOADING', false)
              fetchExperts = resp3.data

              commit('SET_SCENARY_VARIABLES', fetchVariables)
              commit('SET_SCENERIES_REPORT', fetchAnswers)
              fetchExperts.results.forEach((expert, idxexpert) => {
                let answers = []
                let namescenario = ''
                fetchVariables.results.forEach((variable, idxvariable) => {
                  fetchAnswers.results.forEach((answer, idxanswer) => {
                    if (expert.url === answer.expert && variable.id === answer.hypothesis_in_scenario.var_hypothesis.id){
                      answers[idxvariable] = answer.hypothesis_in_scenario.name
                      namescenario = answer.name_scenario
                    }
                  })
                })
                // console.log("asignando:", answers)
                expert['namescenario'] = namescenario
                expert['answers'] = answers
              });
              commit('SET_SCENERIES_EXPERTS', fetchExperts)
              
            })
            .catch(() => {
              store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error realizando acción' })
            })

          })
          .catch(() => {
            store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error realizando acción' })
          })

        })
        .catch(() => {
          store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error realizando acción' })
        })
  },
  fetchMorphAnalysis({ commit }, projectId) {
    commit('SET_LOADING', true)
    store.dispatch('utils/loaderMessage', 'Consultando análisis...' )
    axios.get(appConfig.server_url + `/projects_management/reports/morphanalysis?project_id=${projectId}`)
      .then(resp => {
        commit('SET_LOADING', false)
        store.dispatch('utils/loaderMessage', '' )
        commit('SET_MORPH_DATA', resp.data)
      })
      .catch(() => {
        store.dispatch('utils/message', { type: 'error', title: 'Error', text: 'Error realizando acción' })
        commit('SET_LOADING', false)
        store.dispatch('utils/loaderMessage', '' )
      })
  },
}